import { BaseInputFilter } from "domain/models/base-input-filter";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useFunctions } from "./use-query-functions";

interface UsePermissionCheckProps {
  requiredFunction: string;
}

function usePermissionCheck({ requiredFunction }: UsePermissionCheckProps) {
  const { userPermissions } = useAuthStore();
  const { data: functions, isLoading } = useFunctions({
    limit: 100,
    sortBy: "order",
    sortOrder: "asc",
  } as BaseInputFilter);
  const navigate = useNavigate();

  const hasPermission = useMemo(() => {
    if (isLoading || !functions?.data) {
      return false;
    }
    const currentFunction = functions.data.find(
      (item) => item.name === requiredFunction
    );

    if (!currentFunction) return false;

    const allowThisFunction = userPermissions?.find(
      (item) => item.functionId === currentFunction?.id
    );

    return !!allowThisFunction;
  }, [isLoading, functions, requiredFunction, userPermissions]);

  useEffect(() => {
    if (!isLoading && !hasPermission) {
      navigate("/login?unauthorized=true");
    }
  }, [isLoading, hasPermission, navigate]);

  return { isLoading, hasPermission };
}

export default usePermissionCheck;
